import { once, reject } from "ramda";
import axios from "axios";
import { ONE_SECOND } from "Globals/constants/constants";
import throttle from "lodash.throttle";

const identityhosts = {
    prod: [
        "identity.app.masterdocs.com.au", "prod", "md_direct"
    ],
    failover: [
        [
            "identity.app.failover.masterdocs.com.au", "prod", "md_direct"
        ],
    ],
    local: [
        "localhost:8090", "test", "md_direct"
    ],
};
const ping = async (api, secure = true) => {
    for (let i = 1; i < 5; i++) {
        try {
            let data = localStorage.getItem("login_auth_realms_ping");
            if (!data) {
                const { data: result } = await axios.get(
                    `http${
                        secure ? "s" : ""
                    }://${api}/auth/realms/master/.well-known/openid-configuration`,
                    { responseType: "json" }
                );
                data = result;
            }
            if (data.issuer?.length > 0) {
                return true;
            }
        } catch (e) {
            console.info(`API ${api} is down!`, e);
        }
        await new Promise(res => setTimeout(res, ONE_SECOND * 2 ** i));
    }
    return false;
};

export const choosekeycloakhost = once(async () => {
    const url = new URL(document?.currentScript?.src || window.location);

    const localhosts = [
        "localhost", "127.0.0.1", "internal.docker.host"
    ];
    if (localhosts.includes(window.location.hostname)) {
        const [
            host, realm, clientId
        ] = identityhosts.local;
        await ping(host, false);
        return [
            host, false, realm, clientId
        ];
    }

    let data = localStorage.getItem("login_origin_identity");
    if (!data) {
        const { data: result } = await axios.get(`${url.origin}/identity.txt`);
        data = result;
    }
    const apidefs = data?.split?.("\n").map(i => i.trim().split(","));
    const apihost = [ ...(apidefs.length ? apidefs : [identityhosts.prod]), ...identityhosts.failover, ];
    for (const [
        host, realm, clientId
    ] of apihost) {
        const isAvailable = await ping(host, true);
        if (isAvailable) {
            return [
                host, true, realm, clientId
            ];
        }
    }
    throw new Error(`No api available! Checked ${apihost.join(", ")}`);
});

function decodeToken(strr) {
    let str = strr.split(".")[1];

    str = str.replace(/-/g, "+");
    str = str.replace(/_/g, "/");
    switch (str.length % 4) {
    case 0:
        break;
    case 2:
        str += "==";
        break;
    case 3:
        str += "=";
        break;
    default:
        throw "Invalid token";
    }

    str = decodeURIComponent(escape(atob(str)));

    str = JSON.parse(str);
    return str;
}
let requestinprogress = null;
const internalGetNewToken = kc => {
    if (requestinprogress) {
        return requestinprogress;
    }
    const ifrm = document.createElement("iframe");
    const src = kc.createLoginUrl({
        prompt: "none",
        redirectUri: kc.silentCheckSsoRedirectUri,
    });
    ifrm.setAttribute("src", src);
    ifrm.setAttribute("title", "keycloak-silent-check-sso");
    ifrm.style.display = "none";
    document.body.appendChild(ifrm);
    let messageCallback = null;
    let tm = null;
    requestinprogress = Promise.race([
        new Promise(resolve => {
            messageCallback = function (event) {
                if (event.origin !== window.location.origin || ifrm.contentWindow !== event.source) {
                    return;
                }
                try {
                    const parsed = Object.fromEntries(new URL(event.data).hash.slice(1).split("&")
                        .map(i => i.split("=")));
                    document.body.removeChild(ifrm);
                    window.removeEventListener("message", messageCallback);
                    requestinprogress = null;
                    clearTimeout(tm);
                    resolve({
                        ...parsed,
                        token: parsed.access_token,
                        idTokenParsed: decodeToken(parsed.id_token),
                        tokenParsed: decodeToken(parsed.access_token),
                    }); // or reject if error
                } catch (e) {
                    reject(e);
                }
            };
            window.addEventListener("message", messageCallback);
        }),
        new Promise((_, rej) => {
            tm = setTimeout(() => {
                document.body.removeChild(ifrm);
                window.removeEventListener("message", messageCallback);
                requestinprogress = null;
                rej(new Error("Timeout awaiting message from iframe"));
            }, ONE_SECOND * 10 * 3);
        })
    ]);
    return requestinprogress;
};

let latestResult = null;
export const getNewToken = function (kc, exp = 5) {
    if (!kc.isTokenExpired(exp) && exp > -1) {
        return latestResult || Promise.resolve(kc);
    }
    latestResult = internalGetNewToken(kc);
    return latestResult;
};
